export default __webpack_public_path__ + "static/media/breakaway-journey.dd548628.webp";